// extracted by mini-css-extract-plugin
export var brand = "_redotech-arbiter-lib-icon-brand";
export var compact = "_redotech-arbiter-lib-icon-compact";
export var extraSmall = "_redotech-arbiter-lib-icon-extra-small";
export var icon = "_redotech-arbiter-lib-icon-icon";
export var large = "_redotech-arbiter-lib-icon-large";
export var light = "_redotech-arbiter-lib-icon-light";
export var medium = "_redotech-arbiter-lib-icon-medium";
export var outline = "_redotech-arbiter-lib-icon-outline";
export var primaryDark = "_redotech-arbiter-lib-icon-primary-dark";
export var primaryLight = "_redotech-arbiter-lib-icon-primary-light";
export var primaryModern = "_redotech-arbiter-lib-icon-primary-modern";
export var success = "_redotech-arbiter-lib-icon-success";
export var successSolid = "_redotech-arbiter-lib-icon-success-solid";